// extracted by mini-css-extract-plugin
export default {"title":"_207dc0"};